import { OrbitModule } from 'utils/i18n/TModules';

// Translation Keys
export const AssistantKey = `Assistant`;

// Translation Paths
export const TOrbit = `${OrbitModule}:${AssistantKey}`;
